import React, { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  useTheme,
  Stack,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

export default function HamburgerMenu({ navItems }) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();

  const items = navItems?.map((item, index) => (
    <ListItem
      key={index}
      disablePadding
      sx={{
        mb: ".7rem",
        borderRadius: "1rem",
        overflow: "hidden",
        border: `1px solid ${theme.palette.primary.main}20`,
        background: "rgba(255,255,255,0.03)",
        backdropFilter: "blur(4px)",
        transition: ".25s",
        "&:hover": {
          background: "rgba(255,255,255,0.06)",
          borderColor: theme.palette.primary.main,
          transform: "translateX(-4px)",
        },
      }}
    >
      <ListItemButton
        sx={{
          textAlign: "right",
          borderRadius: "1rem",
          display: "flex",
          justifyContent: "space-between",
          gap: ".8rem",
        }}
        onClick={() => {
          navigate(item?.route);
          setOpen(false);
        }}
      >
        {/* Text */}
        <ListItemText
          primary={item?.name}
          primaryTypographyProps={{
            fontSize: "1.15rem",
            fontWeight: 500,
            color: theme.palette.primary.main,
            textAlign: "right",
          }}
          sx={{ flex: "unset" }}
        />

        {/* Icon (from navItems.icon) */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: theme.palette.primary.main,
            fontSize: "1.4rem",
          }}
        >
          {item?.icon}
        </Box>
      </ListItemButton>
    </ListItem>
  ));

  return (
    <>
      {/* Icon Button */}
      <Stack
        direction={"row"}
        sx={{
          height: "100%",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}
      >
        <IconButton
          sx={{
            display: { xs: "flex", lg: "none" },
            color: theme.palette.primary.main,
            transition: ".3s",
            "&:hover": {
              transform: "scale(1.2)",
            },
          }}
          onClick={() => setOpen(true)}
        >
          <MenuIcon sx={{ fontSize: "2rem" }} />
        </IconButton>

        <Box
          onClick={() => navigate("/")}
          sx={{
            height: "80%",
            width: { xs: "20px", md: "30px" },
            transform: "translateX(-50%)",
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src="/Media/Layout/MainLayout/Navbar/nimobileIcon.png"
            alt="Icon"
          />
        </Box>
      </Stack>

      {/* Drawer */}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: "70%",
            maxWidth: "260px",
            borderRadius: "1rem 0 0 1rem",
            p: "1.2rem",

            // Glass Mode — Dark
            background: "rgba(49,49,49,0.45)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(18px)",
            borderLeft: `1px solid ${theme.palette.primary.main}30`,
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          },
        }}
      >
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: "2rem",
              pb: "1.5rem",
              borderBottom: `1px solid ${theme.palette.primary.main}40`,
            }}
          >
            <Box
              onClick={() => navigate("/")}
              sx={{
                width: "80px",
                height: "100px",
                borderRadius: "1rem",
                overflow: "hidden",
                mb: "1rem",
                // backdropFilter: "blur(8px)",
              }}
            >
              <img
                src="/Media/Layout/MainLayout/Navbar/nimobileIcon.png"
                alt="logo"
                style={{
                  width: "100%",
                  height: "100%",
                  // objectFit: "cover",
                }}
              />
            </Box>

            <Typography
              sx={{
                color: theme.palette.primary.main,
                fontWeight: "600",
                fontSize: "1.25rem",
                letterSpacing: ".5px",
                textAlign: "center",
              }}
            >
              فروشگاه نی موبایل
            </Typography>
          </Box>

          <List>{items}</List>
        </Box>
      </Drawer>
    </>
  );
}
